export enum Languages{
    FRENCH="fr",
    SPANISH="es",
    ENGLISH="en"
}
